import { useMemo } from 'react';
import { mediaManagerLayoutChanged, mediaManagerLayoutClick } from '@wix/bi-logger-media-manager-g6/v2';

import { bi } from '../../../services/loggers/bi';
import { toSettingsLayout } from '../../layout';

export enum LayoutChangeClickOrigin {
  TopRight = 'topRight',
  Actions = 'actions',
}

export const useTrackLayoutChange = () =>
  useMemo(
    () => ({
      trackLayoutClick: (clickOrigin) => bi.logger().report(mediaManagerLayoutClick({ clickOrigin })),
      trackLayoutChange: (previousLayout, currentLayout) =>
        bi.logger().report(
          mediaManagerLayoutChanged({
            previousSelection: toSettingsLayout(previousLayout),
            layout: toSettingsLayout(currentLayout),
          }),
        ),
    }),
    [],
  );
